import React, { useState } from "react";
import {
  Box,
  Tab,
  Tabs,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Button,
  Select,
  MenuItem,
  Tooltip,
  Divider,
  Drawer,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SearchBar from "../../components/SearchBar";
import ChatIcon from "@mui/icons-material/Chat";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

const rows = [
  {
    id: "BOOK_001",
    customerName: "Aman Verma",
    customerPhone: "9876501234",
    orderDateTime: "02 August 2025, 09:30 AM",
    amount: "SAR 120.00",
    method: "Card",
    status: "Pending",
    category: "Electronics",
    subCategory: "Earphones",
    serviceType: "Service1",
    quantity: 1,
    expectedDelivery: "2025-10-17",
    notes: "-",
  },
  {
    id: "BOOK_002",
    customerName: "Rahul Mehta",
    customerPhone: "9812345678",
    orderDateTime: "03 August 2025, 12:15 PM",
    amount: "SAR 250.00",
    method: "Cash on Delivery",
    status: "Accept",
    category: "Clothing",
    subCategory: "T-Shirts",
    serviceType: "Service2",
    quantity: 3,
    expectedDelivery: "2025-10-16",
    notes: "Deliver after 5 PM",
  },
  {
    id: "BOOK_003",
    customerName: "Priya Singh",
    customerPhone: "9876000000",
    orderDateTime: "04 August 2025, 01:45 PM",
    amount: "SAR 500.00",
    method: "Release",
    status: "Ongoing",
    category: "Accessories",
    subCategory: "Watches",
    serviceType: "Service3",
    quantity: 1,
    expectedDelivery: "2025-10-18",
    notes: "Gift wrap item",
  },
  {
    id: "BOOK_004",
    customerName: "Alice Johnson",
    customerPhone: "9876543210",
    orderDateTime: "02 August 2025, 03:30 PM",
    amount: "SAR 199.99",
    method: "Pending",
    status: "Past",
    category: "Clothing",
    subCategory: "Jackets",
    serviceType: "Service4",
    quantity: 2,
    expectedDelivery: "2025-10-15",
    notes: "Gift wrap the item",
  },
  {
    id: "BOOK_005",
    customerName: "Ravi Sharma",
    customerPhone: "9821012345",
    orderDateTime: "05 August 2025, 10:45 AM",
    amount: "SAR 299.50",
    method: "Escrow",
    status: "Cancelled",
    category: "Electronics",
    subCategory: "Headphones",
    serviceType: "Service5",
    quantity: 1,
    expectedDelivery: "2025-10-12",
    notes: "-",
  },
];

const OrderManagement: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState<any | null>(null);
  const [valueTabs, setValueTabs] = useState<number>(0);
  const navigate = useNavigate();
  const handleViewOrder = (order: any) => {
    setSelectedOrder(order);
    setIsDrawerOpen(true);
  };
  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
    setSelectedOrder(null);
  };
  const handleChangeTabs = (event: React.SyntheticEvent, newValue: number) => {
    setValueTabs(newValue);
  };
  const CustomTabPanel: React.FC<TabPanelProps> = ({
    children,
    value,
    index,
  }) => (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box sx={{ p: 2 }}>{children}</Box>}
    </div>
  );
  const a11yProps = (index: number) => ({
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  });
  const tabStatus = ["All", "Pending", "Accept", "Ongoing", "Cancelled", "Past"];
  const filteredRows =
    tabStatus[valueTabs] === "All"
      ? rows
      : rows.filter((row) => row.status === tabStatus[valueTabs]);
  return (
    <>
      <div className="main_title">
        <h1>My Bookings</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - My
          Bookings
        </p>
      </div>
      <div className="stats_boxes gap_m">
        <a className="cards">
          <h2>24</h2>
          <p>142 Bookings (This Month)</p>
          <figure className="sucess">
            <img src="/static/images/bag.svg" alt="Users" />
          </figure>

        </a>

        <a className="cards">
          <figure className="active_order">
            <img src="/static/images/active_order.svg" alt="Active Users" />
          </figure>
          <h2>12</h2>
          <p>Pending Bookings</p>

        </a>

        <a className="cards">
          <figure className="warning">
            <img src="/static/images/reward_icon.svg" alt="Revenue" />
          </figure>
          <h2>1,247</h2>
          <p>Completed</p>

        </a>
        <a className="cards">
          <figure className="blue">
            <img src="/static/images/star.svg" alt="Revenue" />
          </figure>
          <h2>AED 2,450</h2>
          <p>
            Awaying Payout</p>

        </a>
        <a className="cards">
          <figure className="blue">
            <img src="/static/images/star.svg" alt="Revenue" />
          </figure>
          <h2>4 </h2>
          <p>
            Cancelled </p>

        </a>
      </div>
      {/* Tabs */}
      <Box className="custom_tabs1" sx={{ width: "100%", mt: 2 }}>
        <Tabs
          value={valueTabs}
          onChange={handleChangeTabs}
          aria-label="order management tabs"
          className="custom_tabs_links"
        >
          {tabStatus.map((status, index) => (
            <Tab key={status} label={status} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>

      <div className="cards order_wrap">
        <div className="table_header">
          <div className="left_s">
            <SearchBar
              searchTerm={""}
              setDebouncedSearchTerm={() => { }}
              placeholder="Search..."
            />
            <div className="form">
              <div className="control_group">
                <Select fullWidth value={"default"}>
                  <MenuItem disabled value="default">
                    Payment Type
                  </MenuItem>
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Cash">Cash</MenuItem>
                  <MenuItem value="Online">Online</MenuItem>
                  <MenuItem value="Other">Other</MenuItem>
                </Select>
              </div>
            </div>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary" onClick={() => navigate("/")}>
              <DownloadIcon /> Export CSV
            </Button>
          </div>
        </div>

        {/* Table Panels */}
        {tabStatus.map((status, index) => (
          <CustomTabPanel key={index} value={valueTabs} index={index}>
            <TableContainer className="table_container">
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Booking ID</TableCell>
                    <TableCell>Vendor Detail</TableCell>
                    <TableCell>Booking Date/Time</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Payment</TableCell>
                    <TableCell>Category Name</TableCell>
                    <TableCell>Service Name</TableCell>
                    <TableCell>Status</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredRows.length > 0 ? (
                    filteredRows.map((row) => (
                      <TableRow hover key={row.id}>

                        {/* Booking ID */}
                        <TableCell>#{row.id}</TableCell>

                        {/* Customer Detail */}
                        <TableCell>
                          <div className="user_block">
                            <figure>
                              <img src="/static/images/user_placeholder.png" alt="" />
                            </figure>
                            <p>
                              <b>{row.customerName}</b>
                              <span>{row.customerPhone}</span>
                            </p>
                          </div>
                        </TableCell>

                        {/* Booking Date/Time */}
                        <TableCell>{row.orderDateTime}</TableCell>

                        {/* Amount */}
                        <TableCell>{row.amount}</TableCell>

                        {/* Payment */}
                        <TableCell>{row.method}</TableCell>

                        {/* Category Name */}
                        <TableCell>{row.category}</TableCell>

                        {/* Service Name */}
                        <TableCell>{row.serviceType}</TableCell>

                        {/* Status */}
                        <TableCell className="form">
                          <Select size="small" value={row.status}>
                            <MenuItem value="Pending">Pending</MenuItem>
                            <MenuItem value="Accept">Accept</MenuItem>
                            <MenuItem value="Ongoing">Ongoing</MenuItem>
                            <MenuItem value="Past">Completed</MenuItem>
                            <MenuItem value="Cancelled">Cancelled</MenuItem>
                          </Select>
                        </TableCell>

                        {/* Action */}
                        <TableCell>
                          <Box className="table_actions v2">

                            {/* Invoice (Past) OR Chat */}
                            {tabStatus[valueTabs] === "Past" ? (
                              <Tooltip title="Download Invoice">
                                <IconButton>
                                  <SystemUpdateAltIcon color="action" />
                                </IconButton>
                              </Tooltip>
                            ) : (
                              <Tooltip title="Chat">
                                <IconButton onClick={() => navigate("/chat")}>
                                  <ChatIcon color="action" />
                                </IconButton>
                              </Tooltip>
                            )}

                            {/* View Button */}
                            <Tooltip title="View">
                              <IconButton
                                onClick={() => navigate("view")}
                              >
                                <VisibilityIcon color="action" />
                              </IconButton>
                            </Tooltip>

                          </Box>
                        </TableCell>

                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={9} align="center">
                        No orders found.
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>

              </Table>
            </TableContainer>
          </CustomTabPanel>
        ))}
      </div>


    </>
  );
};

export default OrderManagement;
